import React from 'react';

import { CREATE_JOB_APPLICATION_NOTE, DELETE_JOB_APPLICATION_NOTE, GET_JOB_APPLICATION_NOTES, UPDATE_JOB_APPLICATION_NOTE } from '@gql/jobs';
import { EntityNotesContent, EntityNotesManager } from '@modules/notes/components/EntityNotesManager';

interface JobApplicationNotesManagerProps {
    open?: boolean;
    onClose?: () => void;
    jobApplicationId: string;
    entityName?: string;
    variant?: 'dialog' | 'embedded';
}

const jobApplicationNotesConfig = {
    title: 'Notes sur la candidature',
    operations: {
        listQuery: GET_JOB_APPLICATION_NOTES,
        createMutation: CREATE_JOB_APPLICATION_NOTE,
        updateMutation: UPDATE_JOB_APPLICATION_NOTE,
        deleteMutation: DELETE_JOB_APPLICATION_NOTE,
        listDataPath: 'getJobApplicationNotesUpercut',
        createDataPath: 'createJobApplicationNoteUpercut',
        updateDataPath: 'updateJobApplicationNoteUpercut',
    },
    variableBuilder: {
        list: ({ entityId }) => ({ jobApplicationId: entityId }),
        create: ({ entityId, input }) => ({ jobApplicationId: entityId, input }),
        update: ({ entityId, noteId, input }) => ({ jobApplicationId: entityId, noteId, input }),
        delete: ({ entityId, noteId }) => ({ jobApplicationId: entityId, noteId }),
    },
};

export const JobApplicationNotesManager: React.FC<JobApplicationNotesManagerProps> = ({
    open = false,
    onClose = () => undefined,
    jobApplicationId,
    entityName,
    variant = 'dialog',
}) => {
    if (variant === 'embedded') {
        return (
            <EntityNotesContent
                entityId={jobApplicationId}
                entityName={entityName}
                title={jobApplicationNotesConfig.title}
                operations={jobApplicationNotesConfig.operations}
                variableBuilder={jobApplicationNotesConfig.variableBuilder}
            />
        );
    }

    return (
        <EntityNotesManager
            open={open}
            onClose={onClose}
            entityId={jobApplicationId}
            entityName={entityName}
            title={jobApplicationNotesConfig.title}
            operations={jobApplicationNotesConfig.operations}
            variableBuilder={jobApplicationNotesConfig.variableBuilder}
        />
    );
};
